import type { Reference, StoreObject } from '@apollo/client'
import { useMutation } from '@apollo/client'
import { Button, Tooltip, X } from '@chain-zen/ui'
import React from 'react'
import { toast } from 'sonner'

import { REMOVE_TIVE_DEVICE_ID } from '../../data/mutations/tracking'

interface IRemoveTiveDeviceProps {
  shipmentID: string
  tiveDeviceID: string
}

/**
 * RemoveTiveDevice renders a cross icon. When clicked, it removes the tive device.
 */
export const RemoveTiveDevice = (props: IRemoveTiveDeviceProps) => {
  const { shipmentID, tiveDeviceID } = props

  // Mutation to remove the tive device ID
  const [removeTiveDeviceSource] = useMutation(REMOVE_TIVE_DEVICE_ID, {
    onCompleted: () => {
      toast.success('Tive device ID removed successfully.')
    },
    onError: (error) => {
      toast.error(error.message ?? 'Something went wrong.')
    },
    update(cache) {
      cache.modify({
        fields: {
          trackingSources(trackingSources, { readField }) {
            return trackingSources?.data?.filter(
              (trackingSource: { metadata: Reference | StoreObject | undefined }) =>
                tiveDeviceID !== readField('url', trackingSource?.metadata)
            )
          }
        }
      })
    }
  })

  // Remove the tive device ID
  const handleRemoveTiveDeviceID = () => {
    const input = {
      shipmentID,
      tiveDeviceID
    }

    removeTiveDeviceSource({ variables: input })
  }

  return (
    <Tooltip content="Remove this tive device">
      <div>
        <Button variant="ghost" size="icon" className="h-8 w-8" onClick={handleRemoveTiveDeviceID}>
          <X className="h-4 w-4" />
          <span className="sr-only">Remove tive device</span>
        </Button>
      </div>
    </Tooltip>
  )
}
